import angular from 'angular';

import ExperiencePhonePreviewComponent from './experience-phone-preview.component';

const ExperiencePhonePreview = angular
    .module('control-room.event.components.experience-phone-preview', [])
    .component('crExperiencePhonePreview', ExperiencePhonePreviewComponent);

export default ExperiencePhonePreview;
